import React from 'react';
import { InputGroup, Switch, NumericInput, HTMLSelect, Button, Radio, RadioGroup, Icon } from '@blueprintjs/core';
import './ScenarioEvent.css';

const ScenarioEvent = ({ event, onChange, onDelete, dragHandleProps }) => {
    const { time, target, actionType, actionValue, duration } = event;

    const handleFieldChange = (field, value) => {
        onChange({ ...event, [field]: value });
    };

    const handleInterventionSwitch = (checked) => {
        handleFieldChange('actionType', checked ? 'animation' : 'sound');
    };

    return (
        <div className={`scenario-event ${actionType}`}>
            <div className={`event-background ${actionType}`}></div>
            <div className="event-item drag" {...dragHandleProps}>
                <Icon
                    icon="drag-handle-vertical"
                    intent="none"
                    style={{ cursor: 'move', marginRight: '5px' }}
                />
            </div>

            <div className="event-item time">
                <NumericInput
                    placeholder="Start"
                    value={time}
                    onValueChange={(valueAsNumber) => handleFieldChange('time', valueAsNumber)}
                    min={0}
                    stepSize={1}
                    majorStepSize={10}
                    clampValueOnBlur
                    buttonPosition="none"
                />
            </div>
            
            <div className="event-item target">
                <InputGroup
                    placeholder="Target"
                    value={target}
                    onChange={(e) => handleFieldChange('target', e.target.value)}
                />
            </div>

            <div className="event-item action-type">
                <div className="switch-with-labels">
                    <span className="label-left">
                        <Icon icon="volume-up" style={{ marginRight: '5px' }} />
                    </span>
                    <Switch
                        checked={actionType === 'animation'}
                        onChange={(e) => handleInterventionSwitch(e.target.checked)}
                        className="custom-switch"
                    />
                    <span className="label-right">
                        <Icon icon="film" style={{ marginRight: '5px' }} />
                    </span>
                </div>
            </div>
            <div className="event-item action-value">
                {actionType === 'sound' ? (
                    <InputGroup
                        placeholder="Sound File"
                        value={actionValue}
                        onChange={(e) => handleFieldChange('actionValue', e.target.value)}
                    />
                ) : (
                    <InputGroup
                        placeholder="Animation Name"
                        value={actionValue}
                        onChange={(e) => handleFieldChange('actionValue', e.target.value)}
                    />
                )}
            </div>
           
            <div className="event-item duration">
                <NumericInput
                    placeholder="Duration"
                    value={duration}
                    onChange={(e) => handleFieldChange('duration', e.target.value)}
                    min={0}
                    stepSize={1}
                    majorStepSize={10}
                    clampValueOnBlur
                    buttonPosition="none"
                />
            </div>

            <div className="event-item delete">
                <Button className="delete-event-button" intent="none" onClick={onDelete} icon="trash"/>
            </div>
        </div>
    );
};

export default ScenarioEvent;
